//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../GeometricUtilities/GeometricUtilities.FrameOnPathBuilder.js";
import "../no/Section.js";
import "../no/ScCollector.js";
import "../GeometricUtilities/GeometricUtilities.RectangularFrameBuilder.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/ScCollector.js";
import "../no/Section.js";
let d=[[[0,"CanCreateBoundingBox",1,0],[0,"CanJoinCurves",1,0],[0,"CanProjectCurves",1,0],[0,"CanReferenceText",1,0],[0,"CanReverseIntersectionCurve",1,0],[0,"CanUseKerningSpaces",1,0],[0,"CaretPosition",1,0],[0,"EnableCaretPositioning",1,0],[0,"EnableCharacterSpacing",1,0],[0,"Font",0,0],[0,"FontGapFactor",1,0],[0,"FontStyle",1,0],[1,"FrameOnPath",0,"GeometricUtilities.FrameOnPathBuilder",0],[0,"IsAssociative",1,0],[0,"IsPrintMark",1,0],[1,"OnCurvePlacementProfile",0,"Section",0],[0,"OnFacePlacementMethod",1,0],[1,"OnFacePlacementProfile",0,"Section",0],[0,"OrientationMethod",1,0],[0,"OrientationVector",1,"Direction",0],[1,"PlacementFaces",0,"ScCollector",0],[1,"PlanarFrame",0,"GeometricUtilities.RectangularFrameBuilder",0],[1,"PrintMarkThickness",0,"Expression",0],[0,"PrintMarkUsageLabel",1,0],[0,"Script",1,0],[0,"SectionPlane",1,"Plane",0],[1,"Text",0,"Expression",0],[0,"TextString",1,0],[0,"Type",1,0]],[[["fontName","script"],"SelectFont",{},2,0],[[],"UpdateOnSectionPlane",{},0,0],[[],"UpdateOnOrientationVectorReversal",{},0,0]],[]];
SPLM.Features.TextBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.TextBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.TextBuilder.Types = Object.freeze({
    "Planar" : "Planar", "OnCurve" : "OnCurve", "OnFace" : "OnFace"});

SPLM.Features.TextBuilder.OnFacePlacementMethodOptions = Object.freeze({
    "CurvesOnFaces" : "CurvesOnFaces", "SectionPlane" : "SectionPlane"});

SPLM.Features.TextBuilder.OrientationMethodOptions = Object.freeze({
    "Natural" : "Natural", "Vector" : "Vector"});

SPLM.Features.TextBuilder.ScriptOptions = Object.freeze({
    "Other" : "Other", "Western" : "Western", "Baltic" : "Baltic", "ChineseBig5" : "ChineseBig5", "CentralEuropean" : "CentralEuropean", "Gb2312" : "Gb2312", "Greek" : "Greek", "Hangul" : "Hangul", "Mac" : "Mac", "Oem" : "Oem", "Cyrillic" : "Cyrillic", "ShiftJIS" : "ShiftJIS", "Symbol" : "Symbol", "Turkish" : "Turkish", "Vietnamese" : "Vietnamese", "Johab" : "Johab", "Arabic" : "Arabic", "Hebrew" : "Hebrew", "Thai" : "Thai"});

SPLM.Features.TextBuilder.FontStyleOptions = Object.freeze({
    "Regular" : "Regular", "Italic" : "Italic", "Bold" : "Bold", "BoldItalic" : "BoldItalic"});

export default SPLM;